import script from "./PTable2.vue?vue&type=script&setup=true&lang=js"
export * from "./PTable2.vue?vue&type=script&setup=true&lang=js"

import "./PTable2.vue?vue&type=style&index=0&id=59790631&lang=less"

const __exports__ = script;

export default __exports__